module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('v-row', [_c('v-dialog', {
    attrs: {
      "content-class": "all-dialog-wrapper",
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [(!_vm.isLoading) ? [_c('div', {
    staticClass: "div-wrap"
  }, [_c('v-row', {
    staticClass: "close-button"
  }, [_c('v-col', [_c('img', {
    staticClass: "closse-icon-modal",
    attrs: {
      "src": "/static/img/closse.svg"
    },
    on: {
      "click": _vm.closse
    }
  })])], 1), _vm._v(" "), (_vm.step == 6) ? [_c('div', {
    staticClass: "last-step"
  }, [_c('div', [_c('v-row', {
    staticClass: "img-complite-row"
  }, [_c('v-col', {
    staticStyle: {
      "text-align": "-webkit-center",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/regComplited.svg"
    }
  })])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "title-text"
  }, [_c('v-col', [_vm._v("\n                      ВАША АНКЕТА ПРОХОДИТ МОДЕРАЦИЮ\n                    ")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "text-complite-reg"
  }, [_c('v-col', [_vm._v("\n                      Как только анкета будет проверена, Вы получите уведомление на почту и в смс и сможете войти в личный кабинет. "), _c('br'), _vm._v("\n                      Прямо сейчас 1267 человек ищут на сайте услуги адвоката\n                    ")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "row-button"
  }, [_c('v-col', [_c('div', {
    staticClass: "red-button width-compl",
    on: {
      "click": _vm.toHelp
    }
  }, [_vm._v(" Обратиться в поддержку")])])], 1)], 1)])] : _c('v-form', {
    ref: "form",
    staticClass: "wrapper-modal"
  }, [(!(!_vm.isClient && _vm.step == 6)) ? _c('v-row', {
    staticClass: "title-text"
  }, [_c('v-col', [_vm._v("\n                  РЕГИСТРАЦИЯ\n                ")])], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    staticClass: "contoll-button"
  }, [(_vm.step != 6) ? _c('v-col', [_c('img', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": "/static/img/left-modal.svg"
    },
    on: {
      "click": function($event) {
        return _vm.changeStep(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-control"
  }, [_vm._v("Шаг " + _vm._s(_vm.step))]), _vm._v(" "), _c('img', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "src": "/static/img/rignt-modal.svg"
    },
    on: {
      "click": function($event) {
        return _vm.changeStep(1)
      }
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "content-reg"
  }, [_c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [(_vm.step == 1) ? [_c('v-row', [_c('v-col', [_c('ui_sub_title_text', {
    staticStyle: {
      "margin-bottom": "1em"
    }
  }, [_vm._v("Выберите способ регистрации")]), _vm._v(" "), _c('ui_check', {
    attrs: {
      "trueVal": true,
      "falseVal": false
    },
    model: {
      value: (_vm.isClient),
      callback: function($$v) {
        _vm.isClient = $$v
      },
      expression: "isClient"
    }
  }, [_vm._v("\n                            Я клиент\n                        ")]), _vm._v(" "), _c('ui_check', {
    attrs: {
      "trueVal": false,
      "falseVal": true
    },
    model: {
      value: (_vm.isClient),
      callback: function($$v) {
        _vm.isClient = $$v
      },
      expression: "isClient"
    }
  }, [_vm._v("\n                            Я адвокат\n                        ")])], 1)], 1)] : [(_vm.isClient) ? [_c('v-row', {
    staticClass: "input-row"
  }, [_c('v-col', [_c('ui_input', {
    attrs: {
      "label": "Имя",
      "rules": _vm.rules.requared,
      "required": ""
    },
    model: {
      value: (_vm.client.name),
      callback: function($$v) {
        _vm.$set(_vm.client, "name", $$v)
      },
      expression: "client.name"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('ui_input', {
    attrs: {
      "label": "Фамилия",
      "rules": _vm.rules.requared,
      "required": ""
    },
    model: {
      value: (_vm.client.surname),
      callback: function($$v) {
        _vm.$set(_vm.client, "surname", $$v)
      },
      expression: "client.surname"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "input-row"
  }, [_c('v-col', [_c('ui_input', {
    attrs: {
      "label": "Отчество"
    },
    model: {
      value: (_vm.client.patronymic),
      callback: function($$v) {
        _vm.$set(_vm.client, "patronymic", $$v)
      },
      expression: "client.patronymic"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('ui_input', {
    attrs: {
      "label": "E-mail",
      "rules": _vm.rules.email,
      "required": ""
    },
    model: {
      value: (_vm.client.email),
      callback: function($$v) {
        _vm.$set(_vm.client, "email", $$v)
      },
      expression: "client.email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "input-row"
  }, [_c('v-col', [_c('ui_input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('+7(###)-###-##-##'),
      expression: "'+7(###)-###-##-##'"
    }],
    attrs: {
      "label": "Телефон",
      "placeholder": "+7(###)-###-##-##",
      "mask": "'+7(###)-###-##-##'",
      "rules": _vm.rules.requared,
      "required": ""
    },
    model: {
      value: (_vm.client.phone),
      callback: function($$v) {
        _vm.$set(_vm.client, "phone", $$v)
      },
      expression: "client.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "text-obr"
  }, [_c('v-col', [_c('ui_check', {
    attrs: {
      "rules": _vm.rules.isTrue
    },
    model: {
      value: (_vm.client.checkbox),
      callback: function($$v) {
        _vm.$set(_vm.client, "checkbox", $$v)
      },
      expression: "client.checkbox"
    }
  }, [_vm._v("\n                              Я подтверждаю согласие на обработку моих "), _c('a', {
    staticStyle: {
      "color": "rgb(152, 16, 16) !important",
      "margin-left": "0.5em"
    },
    attrs: {
      "href": "/privacy",
      "target": "_blank"
    }
  }, [_vm._v(" персональных данных")])])], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "text-obr"
  }, [_c('v-col', [_c('ui_check', {
    attrs: {
      "rules": _vm.rules.isTrue
    },
    model: {
      value: (_vm.client.checkbox2),
      callback: function($$v) {
        _vm.$set(_vm.client, "checkbox2", $$v)
      },
      expression: "client.checkbox2"
    }
  }, [_vm._v("\n                              Я подтверждаю согласие с "), _c('a', {
    staticStyle: {
      "color": "rgb(152, 16, 16) !important"
    },
    attrs: {
      "href": "/static/doc/offerta.pdf",
      "target": "_blank"
    }
  }, [_vm._v("публичной офертой")])])], 1)], 1)] : _vm._e(), _vm._v(" "), (!_vm.isClient) ? [(_vm.step == 2) ? [_c('v-row', {
    staticClass: "input-row"
  }, [_c('v-col', [_c('ui_input', {
    attrs: {
      "label": "Имя",
      "rules": _vm.rules.requared,
      "required": ""
    },
    model: {
      value: (_vm.advocate.name),
      callback: function($$v) {
        _vm.$set(_vm.advocate, "name", $$v)
      },
      expression: "advocate.name"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('ui_input', {
    attrs: {
      "label": "Фамилия",
      "rules": _vm.rules.requared,
      "required": ""
    },
    model: {
      value: (_vm.advocate.surname),
      callback: function($$v) {
        _vm.$set(_vm.advocate, "surname", $$v)
      },
      expression: "advocate.surname"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "input-row"
  }, [_c('v-col', [_c('ui_input', {
    attrs: {
      "label": "Отчество"
    },
    model: {
      value: (_vm.advocate.patronymic),
      callback: function($$v) {
        _vm.$set(_vm.advocate, "patronymic", $$v)
      },
      expression: "advocate.patronymic"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('ui_input', {
    attrs: {
      "label": "E-mail",
      "rules": _vm.rules.email,
      "required": ""
    },
    model: {
      value: (_vm.advocate.email),
      callback: function($$v) {
        _vm.$set(_vm.advocate, "email", $$v)
      },
      expression: "advocate.email"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "input-row"
  }, [_c('v-col', [_c('ui_input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ('+7(###)-###-##-##'),
      expression: "'+7(###)-###-##-##'"
    }],
    attrs: {
      "label": "Телефон",
      "placeholder": "+7(###)-###-##-##",
      "mask": "+7(###)-###-##-##",
      "rules": _vm.rules.requared,
      "required": ""
    },
    model: {
      value: (_vm.advocate.phone),
      callback: function($$v) {
        _vm.$set(_vm.advocate, "phone", $$v)
      },
      expression: "advocate.phone"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "text-obr"
  }, [_c('v-col', [_c('ui_check', {
    model: {
      value: (_vm.advocate.isFith),
      callback: function($$v) {
        _vm.$set(_vm.advocate, "isFith", $$v)
      },
      expression: "advocate.isFith"
    }
  }, [_vm._v("\n                                С физическими лицами\n                            ")])], 1), _vm._v(" "), _c('v-col', [_c('ui_check', {
    model: {
      value: (_vm.advocate.isUr),
      callback: function($$v) {
        _vm.$set(_vm.advocate, "isUr", $$v)
      },
      expression: "advocate.isUr"
    }
  }, [_vm._v("\n                                С юридическими лицами\n                            ")])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.step == 3) ? [_c('v-row', {
    staticClass: "input-row"
  }, [_c('v-col', [_c('ui_input', {
    attrs: {
      "label": "Стаж работы",
      "rules": _vm.rules.number,
      "required": ""
    },
    model: {
      value: (_vm.advocate.experience),
      callback: function($$v) {
        _vm.$set(_vm.advocate, "experience", $$v)
      },
      expression: "advocate.experience"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('ui_input', {
    attrs: {
      "label": "Номер в реестре",
      "rules": _vm.rules.requared,
      "required": ""
    },
    model: {
      value: (_vm.advocate.certificate),
      callback: function($$v) {
        _vm.$set(_vm.advocate, "certificate", $$v)
      },
      expression: "advocate.certificate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "input-row"
  }, [_c('v-col', [_c('ui_check', {
    attrs: {
      "details": true,
      "value": _vm.advocate.region_id && _vm.advocate.region_id.length == _vm.regions.length ? true : false
    },
    on: {
      "change": function($event) {
        return _vm.setAll($event)
      }
    }
  }, [_vm._v("\n                                  Выбрать все\n                              ")]), _vm._v(" "), _c('ui_auto', {
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "hide_details": false,
      "rules": _vm.rules.requared,
      "deletable_chips": true,
      "chips": true,
      "multiple": true,
      "small_chips": true,
      "label": "Регион",
      "items": _vm.regions
    },
    model: {
      value: (_vm.advocate.region_id),
      callback: function($$v) {
        _vm.$set(_vm.advocate, "region_id", $$v)
      },
      expression: "advocate.region_id"
    }
  })], 1), _vm._v(" "), _c('v-col', [_c('ui_check', {
    attrs: {
      "details": true,
      "value": _vm.advocate.specialization && _vm.advocate.specialization.length == _vm.specializations.length ? true : false
    },
    on: {
      "change": function($event) {
        return _vm.setAllSpec($event)
      }
    }
  }, [_vm._v("\n                                Выбрать все\n                            ")]), _vm._v(" "), _c('ui_auto', {
    staticStyle: {
      "margin-top": "1em"
    },
    attrs: {
      "hide_details": false,
      "rules": _vm.rules.requared,
      "deletable_chips": true,
      "chips": true,
      "multiple": true,
      "small_chips": true,
      "label": "Специализация",
      "items": _vm.specializations
    },
    model: {
      value: (_vm.advocate.specialization),
      callback: function($$v) {
        _vm.$set(_vm.advocate, "specialization", $$v)
      },
      expression: "advocate.specialization"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "helper-reg"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_vm._v("\n                            *Необходимо для привлечения клиентов в Вашем регионе\n                          ")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pre-title"
  }, [_c('v-col', [_vm._v("\n                            Выберите используемые услуги портала:\n                          ")])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "text-obr"
  }, [_c('v-col', [_c('ui_check', {
    model: {
      value: (_vm.advocate.is24h),
      callback: function($$v) {
        _vm.$set(_vm.advocate, "is24h", $$v)
      },
      expression: "advocate.is24h"
    }
  }, [_vm._v("\n                                Готовы ли вы работать в режиме “Тревожная кнопка” 24/7\n                            ")])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.step == 4) ? [_c('v-row', [_c('v-col', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "rules": _vm.rules.requared,
      "required": "",
      "content-class": "elevation-0",
      "label": "Краткая информация о себе"
    },
    model: {
      value: (_vm.advocate.information),
      callback: function($$v) {
        _vm.$set(_vm.advocate, "information", $$v)
      },
      expression: "advocate.information"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "text-obr row-dowload-button align-center"
  }, [_c('v-col', {
    attrs: {
      "cols-md": "8"
    }
  }, [_c('ui_text', [_vm._v("\n                              Прикрепить фотографии паспорта\n                            ")]), _vm._v(" "), _c('ui_sub_text', [_vm._v("\n                              Паспортные данные НЕ публикуются в профиле. Информация нужна только для прохождения модерации на сайте во избежание случаев мошенничеств.\n                            ")])], 1), _vm._v(" "), _c('v-col', [_c('input', {
    ref: "filePasport",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "required": "",
      "accept": "image/png, image/jpeg",
      "type": "file"
    },
    on: {
      "change": _vm.onFileChangePasport
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grey-button",
    on: {
      "click": function($event) {
        return _vm.$refs.filePasport.click()
      }
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.advocate.filePasport ? _vm.advocate.filePasport.name : 'Обзор') + " "), _c('img', {
    attrs: {
      "src": "/static/img/dowload_icon.svg"
    }
  })])])], 1), _vm._v(" "), _c('v-row', {
    staticClass: "text-obr row-dowload-button align-center"
  }, [_c('v-col', {
    attrs: {
      "cols-md": "8"
    }
  }, [_c('ui_text', [_vm._v("\n                              Прикрепить фотографии удостоверения\n                            ")])], 1), _vm._v(" "), _c('v-col', [_c('input', {
    ref: "fileCertificate",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "accept": "image/png, image/jpeg",
      "type": "file"
    },
    on: {
      "change": _vm.onFileChangeCertificate
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grey-button",
    on: {
      "click": function($event) {
        return _vm.$refs.fileCertificate.click()
      }
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.advocate.fileCertificate ? _vm.advocate.fileCertificate.name : 'Обзор') + " "), _c('img', {
    attrs: {
      "src": "/static/img/dowload_icon.svg"
    }
  })])])], 1), _vm._v(" "), (_vm.isFileError) ? _c('v-row', {
    staticClass: "text-obr"
  }, [_c('v-col', {
    staticStyle: {
      "color": "red"
    }
  }, [_c('span', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Обязательные поля!")])])])], 1) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.step == 5) ? [_c('v-row', {
    staticClass: "text-last-step"
  }, [_c('v-col', [_c('v-row', {
    staticClass: "text-obr"
  }, [_c('v-col', [_c('ui_check', {
    attrs: {
      "rules": _vm.rules.isTrue
    },
    model: {
      value: (_vm.client.isOfert),
      callback: function($$v) {
        _vm.$set(_vm.client, "isOfert", $$v)
      },
      expression: "client.isOfert"
    }
  }, [_vm._v("\n                                    Я подтверждаю согласие с  "), _c('a', {
    staticStyle: {
      "color": "rgb(152, 16, 16) !important"
    },
    attrs: {
      "href": "/static/doc/offerta.pdf",
      "target": "_blank"
    }
  }, [_vm._v("публичной офертой")]), _vm._v(" и "), _c('a', {
    staticStyle: {
      "color": "rgb(152, 16, 16) !important"
    },
    attrs: {
      "href": "/polit",
      "target": "_blank"
    }
  }, [_vm._v(" политикой конфиденциальности ")])])], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "adv-fio"
  }, [_c('v-col', [_vm._v("\n                                " + _vm._s(_vm.advocate.surname + ' ' + _vm.advocate.name + ' ' + _vm.advocate.patronymic || '') + "\n                              ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
    staticClass: "text-system-adv"
  }, [_vm._v("Email:")]), _vm._v(_vm._s(_vm.advocate.email) + "\n                              ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
    staticClass: "text-system-adv"
  }, [_vm._v("Телефон:")]), _vm._v(_vm._s(_vm.advocate.phone) + "\n                              ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
    staticClass: "text-system-adv"
  }, [_vm._v("Регион:")]), _vm._v(" "), _vm._l((_vm.advocate.region_id), function(uReg, index) {
    return [_vm._l((_vm.regions), function(reg) {
      return [(uReg == reg.id) ? [_c('br', {
        key: reg.name + uReg.name + index + 'reg'
      }), _vm._v(" "), _c('span', {
        key: reg.name + uReg.name + index + 'reg2'
      }, [_vm._v("\n                                        " + _vm._s(reg.name) + "\n                                      ")])] : _vm._e()]
    })]
  })], 2)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
    staticClass: "text-system-adv"
  }, [_vm._v("Номер в реестре адвокатов:")]), _vm._v(_vm._s(_vm.advocate.certificate) + "\n                              ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
    staticClass: "text-system-adv"
  }, [_vm._v("Стаж:")]), _vm._v(_vm._s(_vm.advocate.experience) + "\n                              ")])], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
    staticClass: "text-system-adv"
  }, [_vm._v("Предоставляемые услуги:")]), _vm._v(" "), (_vm.advocate.isFith) ? [_c('br'), _vm._v(" "), _c('span', [_vm._v("Физическим лицам")])] : _vm._e(), _vm._v(" "), (_vm.advocate.isUr) ? [_c('br'), _vm._v(" "), _c('span', [_vm._v("Юридическим лицам")])] : _vm._e()], 2)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
    staticClass: "text-system-adv"
  }, [_vm._v("Специализация:")]), _vm._v(" "), _vm._l((_vm.advocate.specialization), function(uSpec, index) {
    return [_vm._l((_vm.specializations), function(spec) {
      return [(uSpec == spec.id) ? [_c('br', {
        key: spec.name + uSpec.name + index + 'spec'
      }), _vm._v(" "), _c('span', {
        key: spec.name + uSpec.name + index + 'spec2'
      }, [_vm._v("\n                                        " + _vm._s(spec.name) + "\n                                      ")])] : _vm._e()]
    })]
  })], 2)], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('span', {
    staticClass: "text-system-adv"
  }, [_vm._v("О себе:")]), _vm._v(_vm._s(_vm.advocate.information) + "\n                              ")])], 1)], 1)], 1)] : _vm._e()] : _vm._e()]], 2)]), _vm._v(" "), (_vm.step != 6) ? _c('v-row', {
    staticClass: "row-button"
  }, [_c('v-col', [_c('ui_btn', {
    attrs: {
      "icon": "icon-plus",
      "type": "main-btn full-width",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("\n                    " + _vm._s((_vm.isClient && _vm.step == 2) || (!_vm.isClient && _vm.step == 5) ? 'Зарегистрироваться' : 'Далее') + "                  \n                  ")])], 1)], 1) : _vm._e()], 1)], 2)] : _vm._e(), _vm._v(" "), (_vm.isLoading) ? [_c('div', {
    staticClass: "wrapper-loading"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "red"
    }
  })], 1)] : _vm._e()], 2)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0eb6abb7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/reg/reg.vue
// module id = 338
// module chunks = 2